import { Component, OnInit } from '@angular/core';
import { ActivityEditorBaseComponent } from '../../activity-editor-base/activity-editor-base.component';

@Component({
    selector: 'wm-renewal-review-activity-editor',
    templateUrl: './renewal-review-activity-editor.component.html',
    styleUrls: ['./renewal-review-activity-editor.component.css'],
    standalone: false
})
export class RenewalReviewActivityEditorComponent
  extends ActivityEditorBaseComponent
  implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
